import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'jit-report-question-matching',
  templateUrl: './matching.component.html',
  styleUrls: ['./matching.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
  ],
})
class ReportQuestionMatchingComponent {
  
}

export {
  ReportQuestionMatchingComponent,
};
